import { subscribeRaidControlRealtime } from './raidControlRealtimeClient.js';

// Reuse the authenticated chat socket; canonical records stay in Supabase.
export function subscribeRaidDomainSignals({ unionId, seasonId, seasonNo, onChange, onReconnect, onStatus }) {
  if (!unionId || !seasonId || !Number.isInteger(Number(seasonNo)) || Number(seasonNo) < 1) return () => {};
  const revisions = new Map();
  const subscription = subscribeRaidControlRealtime({
    seasonNo: Number(seasonNo),
    // Callers poll as a fallback for when this socket is not carrying changes; the status tells them
    // when that fallback is redundant.
    onStatus: (payload) => onStatus?.(payload),
    onSnapshot: () => onReconnect?.(),
    onEvent: (event) => {
      if (event?.type !== 'domain.change' || event.unionId !== unionId || event.seasonId !== seasonId) return;
      if (!Number.isSafeInteger(event.revision) || event.revision <= (revisions.get(event.domain) || 0)) return;
      revisions.set(event.domain, event.revision);
      onChange?.(event);
    },
  });
  return () => subscription.unsubscribe();
}
